/**
 *
 * js-LOG记录
 */
function logger(level, ...data) {
  if (typeof window._seagull_send_log === 'function') {
    try {
      window._seagull_send_log(level, ...data);
    } catch (e) { }
  }
}
// 记录日志 日志等级 + 事件名称 + 参数
export function logInfo(level, event, params = {}) {
  const HDFEDITOR_DATA = window.HDFEDITOR_DATA;
  if (HDFEDITOR_DATA) {
    const { userId = 0, hostType = 'DoctorCircle', env = 'web' } = HDFEDITOR_DATA;
    const logKey = `${userId}_${env}_${hostType}`;
    logger(level, `hdf-editor, event: ${logKey}_${event}, params: ${JSON.stringify(params)}`);
  } else {
    logger(level, `hdf-editor, event: ${event}, params: ${JSON.stringify(params)}`);
  }
}
